import getCsrfToken from './csrf_token'
import { ww } from 'bits/global'
import { captureMessage } from 'bits/error_tracker'
import { currentUrl } from 'bits/location'
import { $ } from 'bits/jquery'

let oauthToken = null

export function setOauthToken(token) {
  oauthToken = token
}

$(document).ajaxSend((event, xhr, settings) => {
  if (settings.type != 'GET') {
    xhr.setRequestHeader('X-CSRF-Token', getCsrfToken())
  }
  if (oauthToken && settings.sendOauthToken) {
    xhr.setRequestHeader('Authorization', `Bearer ${oauthToken}`)
  }

  if (ww.uid) {
    xhr.setRequestHeader('X-UID', ww.uid)
  } else {
    const context = { location: currentUrl() }
    captureMessage('No UID set for brahms', { context })
  }
})

export default $.ajax
